import React, { Component } from 'react';
import Image from '../Image';
import styles from './Carousel.module.css';
import Waypoint from 'react-waypoint';

export default class Carousel extends Component {
  state = {
    current: 0,
  };

  changeIndex = step => {
    const { data } = this.props;
    const length = (data && data.length) || 0;
    const { current } = this.state;
    const newCurrent = current + step;
    const validIndex =
      newCurrent < 0 ? 0 : newCurrent >= length ? length - 1 : newCurrent;
    this.setState({
      current: validIndex,
    });
  };

  render() {
    const { data, onEnter } = this.props;
    const { current } = this.state;
    const { title, result } = data[current];
    return (
      <div>
        <p className={styles.title}> {title}</p>
        <div className={styles.container}>
          <img
            className={styles.icon}
            src="/img/left.svg"
            onClick={e => this.changeIndex(-1)}
          />
          <div className={styles.imgContainer}>
            {current !== 0 && current % 23 === 0 && (
              <Waypoint onEnter={e => onEnter(current / 23)} />
            )}
            <Image
              noLazy={true}
              className={styles.renderImage}
              image={result}
            />
          </div>
          <img
            className={styles.icon}
            src="/img/right.svg"
            onClick={e => this.changeIndex(1)}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js